import React from 'react'
import {getWorkflowStage, Workflow, workflowToConfig} from 'yougile-model'
import {Props} from './workflow-in-task'

interface HeaderProps extends Props {
  currentStageId?: string
  workflow: Workflow
}

export const Header = (props: HeaderProps) => {
  const config = workflowToConfig(props.workflow)
  const curStage = getWorkflowStage(props.workflow, props.currentStageId)
  return (
    <>
      <div className="text-16 font-semibold">{props.workflow.name}</div>
      <div className="flex text-obscure-old">
        {(config.stages ?? []).map((stage, i) => (
          <React.Fragment key={stage.name}>
            <span
              className={stage.name === curStage?.name ? 'text-accent-old' : ''}
            >
              {stage.name}
            </span>
            {i < config.stages.length - 1 && <div className="mx-4">»</div>}
          </React.Fragment>
        ))}
      </div>
    </>
  )
}
